import React from 'react';

// Importing custom icons from assets
import icon1 from '../../assets/img/servicearchitecture/1.png';
import icon2 from '../../assets/img/servicearchitecture/2.png';
import icon3 from '../../assets/img/servicearchitecture/3.png';
import icon4 from '../../assets/img/servicearchitecture/4.png';
import icon5 from '../../assets/img/servicearchitecture/5.png';
import icon6 from '../../assets/img/servicearchitecture/6.png';

const ServiceArchitecture = ({ title, description, steps: customSteps }) => {
  const defaultSteps = [
    {
      title: "Project Initiation",
      description: "The very first procedure starts with the contact of clients: gathering the requirements-the project goal and further detailed inputs-to draw a roadmap for the BIM.",
      icon: icon1
    },
    {
      title: "Design Integration",
      description: "Chudasama Outsourcing employs a seamless integration of design inputs obtained from sketches, CAD drawings, and point cloud data into comprehensive BIM models.",
      icon: icon2
    },
    {
      title: "BIM Model Creation",
      description: "They use advanced software at Chudasama Outsourcing in the creation of high-quality, data-rich BIM models which contain all aspects of the structure: layouts and material specifications.",
      icon: icon3
    },
    {
      title: "Clash Detection and Resolution",
      description: "Chudasama Outsourcing finds and intelligently solves the design conflict by highly valued BIM techniques, improving coordination among architectural, structural, and MEP components.",
      icon: icon4
    },
    {
      title: "Review and Revision",
      description: "This involves the reviewing of the BIM models plus necessary customer feedback incorporation in order for it to meet total project requirements.",
      icon: icon5
    },
    {
      title: "Delivery",
      description: "After completing the design BIM model, the organization Chudasama Outsourcing presents its full documentation package and delivers the model to you in the form you prefer-integrating it into your workflow.",
      icon: icon6
    }
  ];

  const steps = customSteps || defaultSteps;

  return (
    <section className="service-architecture">
      <div className="architecture-container">
        <header className="architecture-header">
          <h2>
            {title || (
              <><span>Architectural BIM Modeling Process</span> at Chudasama Outsourcing</>
            )}
          </h2>
          <p>
            {description || "As a professional bim modeling company in USA, we have a highly skilled BIM team to develop architectural BIM Modeling solutions and well-established Our methodology comprises the following phases."}
          </p>
        </header>

        <div className="architecture-grid">
          {steps.map((step, index) => {
            const defaultIcons = [icon1, icon2, icon3, icon4, icon5, icon6];
            const currentIcon = step.icon || defaultIcons[index];
            
            return (
              <div className="architecture-card" key={index}>
                <div className="card-icon">
                  <img 
                    src={currentIcon.src || currentIcon} 
                    alt={step.title} 
                    className="arch-custom-icon"
                  />
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceArchitecture;
